var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9993 12.9993V10.9993H11.666C12.7706 10.9993 13.666 10.1039 13.666 8.99935V8.86602C13.666 7.83508 12.8303 6.99935 11.7993 6.99935H10.9993C9.89478 6.99935 8.99935 7.89478 8.99935 8.99935M10.3327 14.9993H11.666M10.9993 20.3327C5.84469 20.3327 1.66602 16.154 1.66602 10.9993C1.66602 5.84469 5.84469 1.66602 10.9993 1.66602C16.154 1.66602 20.3327 5.84469 20.3327 10.9993C20.3327 16.154 16.154 20.3327 10.9993 20.3327Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9e6d5afbddb4aa1b445c596d0aeb2231.svg";
export { ForwardRef as ReactComponent };